(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-gallery-caption"] && !Shopify.designMode) return;
  try {
    // Live counter + caption for the gallery main image. Listens to the theme
  // slideshow's `slideshow:select` (bubbling) event and reflects the active slide.
  class ProductGalleryCaption extends HTMLElement {
    connectedCallback() {
      this.counterEl = this.querySelector('[data-caption-counter]');
      this.gallery = this.closest('media-gallery');
      this.slideshow = this.gallery?.querySelector('slideshow-component');
      this.handleSelect = this.handleSelect.bind(this);
      this.gallery?.addEventListener('slideshow:select', this.handleSelect);
      this.update(this.activeIndex());
    }

    disconnectedCallback() {
      this.gallery?.removeEventListener('slideshow:select', this.handleSelect);
    }

    handleSelect(event) {
      const index = event.detail?.index;
      this.update(typeof index === 'number' ? index : this.activeIndex());
    }

    slides() {
      return this.slideshow ? [...this.slideshow.querySelectorAll('slideshow-slide')] : [];
    }

    activeIndex() {
      const index = this.slides().findIndex((slide) => slide.getAttribute('aria-hidden') === 'false');
      return index < 0 ? 0 : index;
    }

    update(index) {
      const slides = this.slides();
      const total = slides.length;
      if (!total) return;
      const current = Math.min(Math.max(index, 0), total - 1);
      if (this.counterEl) this.counterEl.textContent = `${current + 1} / ${total}`;
      // Caption label is always the product title (rendered server-side); the
      // per-image alt is intentionally not used, so there's nothing to update.
    }
  }

  if (!customElements.get('product-gallery-caption')) {
    customElements.define('product-gallery-caption', ProductGalleryCaption);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["quick-add-modal"] && !Shopify.designMode) return;
  try {
    // WishlistSuite integration for the product context — TWO independent pieces:
  //  1) PDP stock-row placement: the app auto-injects its wishlist button
  //     (.wishlist-auto-injected) into the buy-buttons form; place() moves it onto the
  //     <product-inventory> stock row, where base.css restyles it as "♥ Wishlist →".
  //  2) Guest-login popup layering (option C): the app's login popup ("Save your wishlist
  //     forever", <div id="wls-guest-modal-overlay"> on <body>) would open BEHIND the quick-add
  //     (a native <dialog> in the browser TOP LAYER). Move the overlay INTO the <dialog> so it
  //     paints IN FRONT while the quick-add stays open, and keep the quick-add from closing when
  //     the shopper dismisses that popup. base.css neutralizes the dialog's transform so the
  //     overlay's position:fixed is viewport-relative (full-screen, centered) again.
  // (The wishlist button's add/remove behavior is owned by the WishlistSuite app.) Rendered once
  // globally in layout/theme.liquid, so it runs on the PDP and where the quick-add opens.
  (function positionProductWishlist() {
    const place = () => {
      for (const inventory of document.querySelectorAll('.product-details product-inventory')) {
        const details = inventory.closest('.product-details');
        const wishlist = details?.querySelector(
          '.wishlist-auto-injected:has(.wishlist-trigger[data-source-page="product"])'
        );
        if (wishlist && wishlist.parentElement !== inventory) {
          inventory.appendChild(wishlist);
          inventory.classList.add('product-inventory--with-wishlist');
        }
      }
    };

    // Move the overlay into the dialog the SAME microtask it becomes visible — react to the app
    // toggling `.wls-open`, not just DOM insertions — so it never paints one frame behind the
    // quick-add (which also stops a tap on that frame from falling through and closing it).
    let guestOverlayWatched = false;
    const syncGuestOverlayLayer = () => {
      const overlay = document.getElementById('wls-guest-modal-overlay');
      if (!overlay) return;

      const relocate = () => {
        const shown =
          overlay.classList.contains('wls-open') &&
          !overlay.hidden &&
          getComputedStyle(overlay).display !== 'none';
        const modal = document.querySelector('.quick-add-modal[open]');
        if (shown && modal && overlay.parentElement !== modal) {
          modal.appendChild(overlay);
        } else if (
          !shown &&
          overlay.parentElement &&
          overlay.parentElement.classList.contains('quick-add-modal')
        ) {
          // Hidden again → return to <body> so the dialog's :has() un-matches (its open/close
          // animations aren't left suppressed) and the shared singleton overlay is free for
          // non-quick-add contexts (e.g. product-card hearts).
          document.body.appendChild(overlay);
        }
      };

      relocate();
      if (!guestOverlayWatched) {
        guestOverlayWatched = true;
        new MutationObserver(relocate).observe(overlay, {
          attributes: true,
          attributeFilter: ['class', 'style', 'hidden'],
        });
      }
    };

    // While the guest login popup is open over the quick-add, a click on it (its backdrop, or a
    // dismiss that detaches the overlay mid-click) must NOT close the quick-add underneath.
    // The quick-add's DialogComponent closes on any click it judges "outside" its content
    // (assets/dialog.js #handleClick, a bubble listener on <quick-add-dialog>). Guard it with a
    // listener on the <dialog> itself: being a descendant of <quick-add-dialog>, its bubble
    // handler runs BEFORE the component's, so stopPropagation() keeps the click from reaching
    // #handleClick. A capture pass snapshots "was the popup open?" first, since the app may
    // strip `.wls-open` while handling the same click.
    const guardQuickAddCloseWhileGuestOpen = () => {
      const dialog = document.querySelector('.quick-add-modal');
      if (!dialog) return;
      let guestOpenAtClickStart = false;
      dialog.addEventListener(
        'click',
        () => {
          const overlay = document.getElementById('wls-guest-modal-overlay');
          guestOpenAtClickStart = !!overlay && overlay.classList.contains('wls-open');
        },
        true
      );
      dialog.addEventListener('click', (event) => {
        if (guestOpenAtClickStart) event.stopPropagation();
        guestOpenAtClickStart = false;
      });
    };

    const init = () => {
      place();
      guardQuickAddCloseWhileGuestOpen();
      // Catch the app's async injection / re-injection and the overlay being added to <body>:
      // re-place the PDP button, and syncGuestOverlayLayer attaches the overlay's own attribute
      // observer so it reacts the instant the app shows/hides the guest popup.
      new MutationObserver(() => {
        place();
        syncGuestOverlayLayer();
      }).observe(document.body, {
        childList: true,
        subtree: true,
      });
    };

    if (document.body) {
      init();
    } else {
      document.addEventListener('DOMContentLoaded', init);
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["reviews-scroll"] && !Shopify.designMode) return;
  try {
    (function reviewsScroll() {
    const HASH = '#judgeme-reviews';
    const reduceMotion = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const target = () => document.getElementById('judgeme-reviews');

    const scrollToReviews = (behavior) => {
      const el = target();
      if (!el) return false;
      el.scrollIntoView({ behavior, block: 'start' });
      return true;
    };

    // The late re-alignment below can land seconds after the click, so stop owning the scroll
    // as soon as the shopper takes it over. wheel/touchmove/keydown come from them only —
    // scrollIntoView never fires these, unlike 'scroll'.
    let shopperTookOver = false;
    const takeOverEvents = ['wheel', 'touchmove', 'keydown'];
    const markTakeover = () => {
      shopperTookOver = true;
    };
    const watchForTakeover = () => {
      shopperTookOver = false;
      for (const type of takeOverEvents) {
        window.addEventListener(type, markTakeover, { passive: true });
      }
    };

    // Own the scroll: an initial smooth scroll for the "suave" feel, then two instant
    // corrections — content above/within the reviews (recommendations, the Judge.me widget,
    // lazy images) reflows async and would otherwise leave a native jump short of the target.
    const settleScroll = () => {
      watchForTakeover();
      scrollToReviews(reduceMotion() ? 'auto' : 'smooth');
      setTimeout(() => scrollToReviews('auto'), 400);
      setTimeout(() => scrollToReviews('auto'), 1000);
    };

    document.addEventListener('click', (event) => {
      const modal = event.target.closest?.('.quick-add-modal[open]');
      if (modal) {
        // Quick-add: the reviews section isn't in the modal → clicking the rating (the compact
        // "★ 4,8" — its count link is hidden, so match the whole rating-wrapper too) sends the
        // shopper to the product's PDP reviews.
        if (!event.target.closest('.rating-count__link, .rating-wrapper')) return;
        const productLink = modal.querySelector('.view-product-title a[href], .product-header a[href]');
        const href = productLink?.getAttribute('href');
        if (!href) return; // no product URL available → harmless no-op
        event.preventDefault();
        window.location.assign(href.split('#')[0] + HASH);
        return;
      }

      // PDP (in-page): the native #judgeme-reviews link owns the scroll (async reflow correction).
      const link = event.target.closest?.('.rating-count__link');
      if (!link) return;
      if (target()) {
        event.preventDefault();
        if (window.history.replaceState) window.history.replaceState(null, '', HASH);
        settleScroll();
      }
    });

    // Arrival on the PDP with the hash (e.g. navigated from the quick-add) → scroll once settled.
    if (window.location.hash === HASH) {
      if (document.readyState === 'complete') settleScroll();
      else window.addEventListener('load', settleScroll, { once: true });
    }

    // The Judge.me widget loads on scroll (snippets/judgeme-deferred-load.liquid) and reflows the
    // page seconds after the click, so re-align once it reports that it has rendered — unless the
    // shopper has moved on by then, in which case yanking them back would be worse than a short
    // landing.
    document.addEventListener(
      'aristopet:judgeme-reviews-rendered',
      () => {
        if (shopperTookOver || window.location.hash !== HASH) return;
        scrollToReviews(reduceMotion() ? 'auto' : 'smooth');
      },
      { once: true }
    );
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["size-guide-scroll"] && !Shopify.designMode) return;
  try {
    (function sizeGuideScroll() {
    const HASH = '#size-guide';
    const reduceMotion = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const target = () => document.getElementById('size-guide');

    const openAndScroll = () => {
      const el = target();
      if (!el) return false;
      if (el.tagName === 'DETAILS') el.open = true;
      const behavior = reduceMotion() ? 'auto' : 'smooth';
      el.scrollIntoView({ behavior, block: 'start' });
      // Content above (gallery, recommendations) reflows async — re-scroll once settled.
      setTimeout(() => el.scrollIntoView({ behavior: 'auto', block: 'start' }), 400);
      return true;
    };

    document.addEventListener('click', (event) => {
      const trigger = event.target.closest?.('.variant-option__size-guide');
      if (!trigger) return;

      const modal = trigger.closest('.quick-add-modal[open]');
      if (modal) {
        // Quick-add: the size guide isn't opened in the modal → go to the product's PDP.
        const productLink = modal.querySelector('.view-product-title a[href], .product-header a[href]');
        const href = productLink?.getAttribute('href');
        if (!href) return; // no product URL → harmless no-op
        event.preventDefault();
        window.location.assign(href.split('#')[0] + HASH);
        return;
      }

      // PDP (in-page): open the collapse + scroll.
      if (target()) {
        event.preventDefault();
        if (window.history.replaceState) window.history.replaceState(null, '', HASH);
        openAndScroll();
      }
    });

    // Arrival on the PDP with the hash (e.g. navigated from the quick-add) → open + scroll.
    if (window.location.hash === HASH) {
      if (document.readyState === 'complete') openAndScroll();
      else window.addEventListener('load', openAndScroll, { once: true });
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
